import { FlatList } from '@openx/components-core/lib/TransferList/FlatList.tsx';
import { ActionType } from '@openx/components-core/lib/TransferList/types.ts';
import { InventoryListFormFields, type InventoryListFormState, type ListData } from '@openx/types/inventoryList.ts';
import { useFormContext } from 'react-hook-form';

type InventoryListFlatListProps = {
  listData: ListData[];
  handleRemoveItem: (id: string) => void;
  handleRemoveAll: () => void;
};
export const InventoryListFlatList = ({ listData, handleRemoveAll, handleRemoveItem }: InventoryListFlatListProps) => {
  const {
    formState: { errors },
  } = useFormContext<InventoryListFormState>();

  return (
    <FlatList
      dataTest="transfer-list-bulk-list"
      data={listData}
      handleRowClick={handleRemoveItem}
      isSelectedList={true}
      handleRemoveAll={handleRemoveAll}
      actionType={ActionType.Add}
      isDisabled={false}
      hasBulkInput={false}
      errorMessage={errors[InventoryListFormFields.VALUES]?.message}
    />
  );
};
